/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isAcknowledged, isPersonalPortal } from 'actions/common';
import { getCompanySettings } from 'actions/common/companySettings';
import { setAcknowledgement } from 'actions/settings';

import launchBeneficialOwnerModal from 'containers/Payments/BeneficialOwnerCollectionPanel/Modal';

import useQueryParams from 'hooks/location/useQueryParams';

import { useHasNotDoneBigAction, useHasLoggedInOnThisPage } from '../utils';

const BeneficialOwnerPromptWorkflowStep = ({
  active,
  updateState
}) => {
  // Hooks
  const dispatch = useDispatch();
  const { forceNotification } = useQueryParams([ 'forceNotification' ]);

  const hasFlag = useSelector(
    state => getCompanySettings(state).needsBeneficialOwnerInfo
    && !isAcknowledged(state, 'BeneficialOwnerCollectionAtLogin')
  );
  const hasNotDoneBigAction = useHasNotDoneBigAction();
  const loggedInThisPage = useHasLoggedInOnThisPage();
  const shouldShow = hasFlag && loggedInThisPage && hasNotDoneBigAction;

  const canShow = useSelector(state => !isPersonalPortal(state));

  const willShow = canShow && (forceNotification === 'beneficialOwnerPrompt' || shouldShow);

  useEffect(
    () => {
      updateState(!willShow ? 'skipped' : 'loaded');
    },
    [ willShow ]
  );

  const execute = async () => {
    dispatch({ type: 'HasDoneOncePerSessionAction' });
    await dispatch(launchBeneficialOwnerModal({}));
    dispatch(setAcknowledgement('BeneficialOwnerCollectionAtLogin'));
    updateState('completed');
  };

  useEffect(
    () => {
      if (willShow && active) {
        // useEffect doesn't like being passed an async function - hence why this broken out
        execute();
      }
    },
    [ active ]
  );

  // Render
  return <></>;
};

export default BeneficialOwnerPromptWorkflowStep;